/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'tss-react/mui';
import { useDispatch, useSelector } from 'react-redux';
import ModalDialog from 'src/components/ModalDialog/index';
import AdminSignInAsForm from 'src/containers/AdminSignInAs/AdminSignInAsForm';
import { getUsersList } from 'src/actions/accountActions';

import adminSignInAsStyle from 'src/containers/AdminSignInAs/adminSignInAs.style';
import helpers from 'src/helpers';
import { PERMISSIONS_SYSTEM_CODE } from 'src/constants/permissions';

// CON-1963. Two modes. Forced: an Admin-role account always gets this
// dialog, and closing it logs out, as before. Optional: any other holder of
// SIGN_IN_AS opens it from the account menu (open = true), and closing it
// just closes it (Cancel). The server checks the same permission.
function AdminSignInAs({
  classes,
  logout,
  open = false,
  onCancel = () => { },
}) {
  const dispatch = useDispatch();
  const { user, usersList } = useSelector((state) => state.account);
  const isAdmin = helpers.isUserAdmin(user);
  const canSignInAs = helpers.permissions.doesUserHavePermission(
    PERMISSIONS_SYSTEM_CODE.SIGN_IN_AS,
    user?.userRole?.permissions,
  );
  const isForced = isAdmin;
  const isVisible = isForced || (open && canSignInAs);

  const okButtonProps = {
    form: 'formAdminSignInAs',
    type: 'primary',
  };

  const handleCloseModal = () => {
    if (isForced) {
      logout();
      return;
    }
    onCancel();
  };

  useEffect(() => {
    if (isVisible) {
      dispatch(getUsersList());
    }
  }, [dispatch, isVisible]);

  return isVisible && (
    <ModalDialog
      title="Sign-In As"
      onClose={handleCloseModal}
      onOk={() => {}}
      okButtonProps={okButtonProps}
      content={(
        <AdminSignInAsForm
          classes={classes}
          usersList={usersList}
        />
      )}
      closeText={isForced ? 'Log Out' : 'Cancel'}
      okText="Sign-In As"
      loading={usersList?.loading}
      isVisible
      closeOnClickOnlyTheButton
      largeModal
    />
  );
}

AdminSignInAs.propTypes = {
  classes: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
  open: PropTypes.bool,
  onCancel: PropTypes.func,
};

export default withStyles(AdminSignInAs, adminSignInAsStyle);
